/**
 * Performance Chart Constants
 *
 * Configuration values and constants for the PerformanceChart component.
 */

import type { TimePeriod } from "./types";

/**
 * Chart dimensions and padding
 */
export const CHART_CONFIG = {
  width: 400,
  height: 220,
  paddingTop: 20,
  paddingBottom: 40,
  paddingLeft: 50,
  paddingRight: 20,
} as const;

/**
 * Available time periods
 */
export const TIME_PERIODS: TimePeriod[] = ["1M", "3M", "6M", "1Y"];

/**
 * Colors for chart elements
 */
export const CHART_COLORS = {
  fund: {
    stroke: "#10b981", // emerald-500
    fill: "rgba(16, 185, 129, 0.1)",
  },
  benchmark: {
    stroke: "#6b7280", // gray-500
    strokeDash: "4,4",
  },
  invested: {
    stroke: "#f59e0b", // amber-500
    strokeDash: "8,4",
  },
  grid: {
    stroke: "currentColor",
    opacity: 0.1,
  },
  tooltip: {
    bg: "rgba(0, 0, 0, 0.8)",
    text: "#ffffff",
  },
} as const;
